import axios from 'axios';

export const HTTP = axios.create( {
	baseURL: rtwp.root
} );



// WEBPACK FOOTER //
// ./src/axios/axios.js